<template>
    <div>
        <div class="row">
            <div class="col-sm-12">
                <div>
                    <div class="content">
                        <div class="col-sm-3">
                            <div v-for="category in filteredTopCategories" class="category">
                                <div class="btn btn-danger category-btn" style="display: inline-flex" :class="{'active': category.id === selectedCategory}" @click="showCategoriesForParentId(category)">
                                    <div style="width: 30px;">
                                        <img v-if="category.imageLocation" height="20" style="margin-right: 5px;" :src="BACKEND_BASE_URL + '/images/' + category.imageLocation">
                                    </div>
                                    {{ getLocale() == 'nl' ? category.dutchTranslation : category.frenchTranslation}}
                                </div>
                                <i v-if="_self.$can('btonly')" class="glyphicon glyphicon-trash" @click="deleteCategory(category)"></i>
                                <i v-if="_self.$can('btonly')" class="glyphicon glyphicon-edit" style="margin-left: 5px" @click="showEditCategoryModal(category)"></i>
                            </div>
                            <div v-if="$can('btonly')" class="btn btn-danger add-category-btn" @click="showAddCategoryModal()">
                                <i class="glyphicon glyphicon-plus"></i>
                            </div>
                        </div>
                        <div class="col-sm-9" v-if="topCategories.length > 0 && selectedCategory !== null">
                            <div class="row">
                                <div class="col-sm-12" style="margin-bottom: 20px;">
                                    <ol class="breadcrumb col-sm-7" v-if="filteredBreadcrumbs.length > 1 && !shouldShowAllProducts">
                                        <li class="breadcrumb-link" v-for="(breadcrumb, index) in filteredBreadcrumbs">
                                            <a @click="showCategoriesForParentId(breadcrumb, index)">{{ getLocale() == 'nl' ? breadcrumb.dutchTranslation : breadcrumb.frenchTranslation}}</a>
                                        </li>
                                    </ol>
                                    <form @submit.prevent="searchAllProducts()">
                                        <button type="submit" class="btn btn-danger pull-right">{{$t('search')}}</button>
                                        <div class="pull-right col-sm-3 no-padding">
                                            <div class="input-group">
                                                <span class="input-group-addon glyphicon glyphicon-search"></span>
                                                <input type="text" :placeholder="$t('search') + '...'" v-model="searchInputEntireSite" class="form-control">
                                            </div>
                                        </div>
                                    </form>
                                </div>
                                <div class="row">
                                    <div class="col-sm-12">
                                        <div>
                                            <div class="pull-right mb-10 col-sm-7">
                                                <button class="btn btn-success pull-right" v-if="$can('btonly')" @click="showAddCategoryModal(selectedCategory)">Sub-category toevoegen</button>
                                                <button class="btn btn-success pull-right" v-if="categoriesByParent.length === 0 && $can('btonly')" @click="showAddProductModal(selectedCategory)">Product toevoegen</button>
                                                <button class="btn btn-success pull-right" v-if="$can('btonly') && products.length > 0" @click="showChangeCategoryModal(selectedCategory)">Producten overzetten</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-12">
                                    <div v-for="category in filteredCategoriesByParent" v-if="!shouldShowAllProducts" class="col-sm-3 card">
                                        <i class="glyphicon glyphicon-info-sign text-center" style="padding-bottom: 5px;" @click="showCategoryInformationModal(category.id)"></i>
                                        <i v-if="_self.$can('btonly')" class="glyphicon glyphicon-trash pull-left" style="padding-bottom: 5px;" @click="deleteCategory(category)"></i>
                                        <i v-if="_self.$can('btonly')" class="glyphicon glyphicon-edit pull-right" style="padding-bottom: 5px; margin-top: -19px !important" @click="showEditCategoryModal(category)"></i>
                                        <img class="card" @click="showCategoriesForParentId(category)" v-if="category.imageLocation" :src="BACKEND_BASE_URL + '/images/' + category.imageLocation">
                                        <img class="card" @click="showCategoriesForParentId(category)" v-if="!category.imageLocation" src="../assets/no-image.svg">
                                        <p @click="showCategoriesForParentId(category)">{{ getLocale() == 'nl' ? category.dutchTranslation : category.frenchTranslation}}</p>
                                    </div>
                                    <div v-if="shouldShowAllProducts" v-for="category in searchedCategories" class="col-sm-3 card">
                                        <i v-if="_self.$can('btonly')" class="glyphicon glyphicon-trash pull-left" @click="deleteCategory(category)"></i>
                                        <i v-if="_self.$can('btonly')" class="glyphicon glyphicon-edit pull-right" @click="showEditCategoryModal(category)"></i>
                                        <img class="card" @click="showCategoriesForParentId(category)" v-if="category.imageLocation" :src="BACKEND_BASE_URL + '/images/' + category.imageLocation">
                                        <img class="card" @click="showCategoriesForParentId(category)" v-if="!category.imageLocation" src="../assets/no-image.svg">
                                        <p @click="showCategoriesForParentId(category)">{{ getLocale() == 'nl' ? category.dutchTranslation : category.frenchTranslation}}</p>
                                    </div>
                                    <div v-if="products.length > 0">
                                        <div class="panel">
                                            <table id="products" class="table">
                                                <thead>
                                                    <tr>
                                                        <td></td>
                                                        <td>{{$t("article_number")}}</td>
                                                        <td>{{$t("article_name")}}</td>
                                                        <td v-if="loggedInCustomer.showPrices">{{$t("price")}}</td>
                                                        <td v-if="loggedInCustomer.id">{{$t("discount")}}</td>
                                                        <td v-if="$can('btonly')">Actief</td>
                                                        <td v-if="$can('btonly')" style="white-space: nowrap">Pop-up</td>
                                                        <td v-if="$can('btonly')">Aanbieding</td>
                                                        <td></td>
                                                        <td></td>
                                                        <td v-if="$can('btonly')"></td>
                                                        <td></td>
                                                        <td v-if="$can('btonly')"></td>
                                                        <td v-if="$can('btonly')"></td>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr style="height: 75px;" v-for="product in filteredProducts">
                                                        <td v-if="product.imageLocation" class="col-sm-1 align-middle">
                                                            <lightbox :caption="true"
                                                                      :images="[{src: BACKEND_BASE_URL + '/images/' + product.imageLocation, caption: product.dutchTitle}]">
                                                            </lightbox>
                                                        </td>
                                                        <td v-if="!product.imageLocation" class="col-sm-1 align-middle">
                                                            <img src="../assets/no-image.svg" style="max-width: 100px;">
                                                        </td>
                                                        <td class="align-middle">{{product.articleNumber}}</td>
                                                        <td class="align-middle"><strong>{{ getLocale() == 'nl' ? product.dutchTitle : product.frenchTitle}}</strong></td>
                                                        <td v-if="loggedInCustomer.showPrices" class="align-middle">€{{parseFloat(product.price).toFixed(2)}} <span v-if="product.customPrice"><i class="glyphicon glyphicon-info-sign" v-tooltip="'speciale prijs'"></i></span></td>
                                                        <td v-if="loggedInCustomer.id" class="align-middle">{{product.discount || 0}}%</td>
                                                        <td class="align-middle" v-if="_self.$can('btonly')"><input type="checkbox" v-model="product.active" @click="toggleProductActivation(product.id, product.active)"></td>
                                                        <td class="align-middle" v-if="_self.$can('btonly')"><input type="checkbox" v-model="product.star" @click="toggleProductStar(product.id, product.star)"></td>
                                                        <td class="align-middle" v-if="_self.$can('btonly')"><input type="checkbox" v-model="product.offer" @click="toggleProductOffer(product.id, product.offer)"></td>
                                                        <td class="align-middle"><i class="glyphicon glyphicon-info-sign" @click="showProduct(product.id)"></i></td>
                                                        <td class="align-middle" style="white-space: nowrap">
                                                            <input type="number" min="1" class="form-control align-middle" style="width: 75px; display: inline-block;" v-model="product.amount" />
                                                            <button class="btn btn-xs btn-success align-middle" style="height: 32px;" @click="orderProduct(product)">{{$t("order")}}</button>
                                                        </td>
                                                        <td class="align-middle" v-if="_self.$can('btonly')"><i class="glyphicon glyphicon-edit" @click="editProduct(product.id)"></i></td>
                                                        <td class="align-middle"><i class="glyphicon glyphicon-list" v-tooltip="'Toon soortgelijke producten'" @click="listCategory(product.categoryId)"></i></td>
                                                        <td class="align-middle" v-if="_self.$can('btonly')"><i class="glyphicon glyphicon-duplicate" @click="duplicateProduct(product)"></i></td>
                                                        <td class="align-middle" v-if="_self.$can('btonly')"><i class="glyphicon glyphicon-trash" @click="deleteProduct(product.id)"></i></td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                            <pagination v-model="currentPage" :records="records" :per-page="perPage" :options="paginationOptions" @paginate="paginate"></pagination>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <bt-footer />
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import BtFooter from './BTFooter.vue'
    import AddCategoryModal from './modals/AddCategory.vue'
    import * as types from '../store/mutation-types'
    import Pagination from 'vue-pagination-2'

    export default {
        name: 'Products',
        components: {
            BtFooter,
            AddCategoryModal,
            Pagination
        },
        data() {
            return {
                BACKEND_BASE_URL: process.env.VUE_APP_BACKEND_BASE_URL,
                selectedCategory: 1,
                showModal: false,
                searchInput: '',
                searchInputEntireSite: '',
                shouldShowAllProducts: false,
                currentPage: 1,
                perPage: 10,
                paginationOptions: {
                    texts: {
                        count: ''
                    }
                }
            }
        },
        created() {
            document.title = 'Brabant-Tools | Producten'
            //this.$store.dispatch('getTopCategories').then(() => {
            //    if (this.topCategories.length === 0) {
            //        this.selectedCategory = null
            //    } else {
            //        this.$store.commit(types.ADD_BREADCRUMB, this.topCategories[0])
            //        this.$store.dispatch('getCategoriesByParent', this.topCategories[0].id)
            //        this.$store.dispatch('getProductsByCategory', this.topCategories[0].id)
            //    }
            //})
            var categoryId = this.$route.params.id;
            this.$store.dispatch('getTopCategories').then(() => {
                if (this.topCategories.length != 0) {
                    if (!categoryId) {
                        categoryId = this.topCategories[0].id;
                    }
                    //alert(categoryId);
                    this.selectedCategory = categoryId
                    //this.$store.commit(types.ADD_BREADCRUMB, categoryId)
                    this.$store.dispatch('getCategoriesByParent', categoryId)
                    this.$store.dispatch('getProductsByCategory', categoryId).then(() => {
                        if (this.products && this.loggedInCustomer.id) {
                            this.$store.dispatch('getDiscounts').then(() => {
                                this.$store.commit(types.ADD_DISCOUNTS_TO_PRODUCTS, this.discounts)
                                this.$store.dispatch('getPricesForCustomerOnAuth').then(() => {
                                    this.$store.commit(types.ADD_CUSTOMER_SPECIFIC_PRICES_TO_PRODUCTS, this.customerSpecificPrices)
                                })
                            })
                        }
                    })
                }
            })
        },
        methods: {
            getLocale() {
                return this.$i18n.locale
            },
            searchAllProducts() {
                if (this.searchInputEntireSite.length > 2) {
                    this.$store.dispatch('searchAllProducts', this.searchInputEntireSite).then(() => {
                        this.$store.dispatch('searchAllCategories', this.searchInputEntireSite)
                        if (this.products && this.loggedInCustomer.id) {
                            this.$store.dispatch('getDiscounts').then(() => {
                                this.$store.commit(types.ADD_DISCOUNTS_TO_PRODUCTS, this.discounts)
                                this.$store.dispatch('getPricesForCustomerOnAuth').then(() => {
                                    this.$store.commit(types.ADD_CUSTOMER_SPECIFIC_PRICES_TO_PRODUCTS, this.customerSpecificPrices)
                                })
                            })
                        }
                    })
                    this.shouldShowAllProducts = true
                }
            },
            showEditCategoryModal(category) {
                this.$modal.show('edit-category-modal', { category: category })
            },
            showAddCategoryModal(parentId) {
                this.$modal.show('add-category-modal', { parentCategory: parentId })
            },
            showAddProductModal(categoryId) {
                this.$modal.show('add-product-modal', { category: categoryId })
            },
            showChangeCategoryModal(categoryId) {
                this.$modal.show('change-category-modal', { category: categoryId })
            },
            showCategoryInformationModal(categoryId) {
                this.$modal.show('show-category-info-modal', { category: categoryId })
            },
            orderProduct(product) {
                if (isNaN(product.amount)) {
                    product.amount = 1
                }
                this.$store.commit(types.ADD_PRODUCT_TO_SHOPPING_CART, product)
                this.$store.dispatch('saveShoppingCart', this.loggedInCustomer.id)
                if (this.getLocale() === 'nl') {
                    this.$notify({ group: 'success', type: 'success', title: 'Succes', text: 'Product is toegevoegd aan je winkelwagen!' })
                } else {
                    this.$notify({ group: 'success', type: 'success', title: 'Succès', text: 'Le produit a été ajouté à votre panier!' })
                }
            },
            editProduct(productId) {
                this.$modal.show('edit-product-modal', { productId: productId })
            },
            showProduct(productId) {
                this.$modal.show('show-product-modal', { productId: productId })
            },
            duplicateProduct(product) {
                let objCopy = Object.assign({}, product)
                objCopy.articleNumber = objCopy.articleNumber + '-kopie'
                this.$store.commit(types.SET_PRODUCT_TO_CREATE, objCopy)
                this.$store.dispatch('createProduct')
            },
            deleteProduct(productId) {
                this.$swal({
                    title: 'Let op!',
                    text: 'Je staat op het punt om een product te verwijderen. Deze actie kan niet ongedaan worden!',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Verwijderen',
                    cancelButtonText: 'Annuleren'
                }).then((result) => {
                    if (result) {
                        this.$store.commit(types.REMOVE_PRODUCT_FROM_PRODUCTS, productId)
                        this.$store.dispatch('deleteProduct', productId)
                    }
                })
            },
            deleteCategory(category) {
                this.$swal({
                    title: 'Let op!',
                    text: 'Je staat op het punt om een categorie te verwijderen. Deze actie kan niet ongedaan worden!',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Verwijderen',
                    cancelButtonText: 'Annuleren'
                }).then((result) => {
                    if (result) {
                        this.$store.commit(types.REMOVE_CATEGORY_FROM_CATEGORIES, category)
                        this.$store.dispatch('deleteCategory', category.id)
                    }
                })
            },
            showCategoriesForParentId(category, index) {
                //this.selectedCategory = parent.id
                //this.shouldShowAllProducts = false
                //if (parent.parentId) {
                //    if (index) {
                //        this.$store.commit(types.REMOVE_BREADCRUMB, index)
                //    }
                //    this.$store.commit(types.ADD_BREADCRUMB, parent)
                //} else {
                //    this.$store.commit(types.SET_BREADCRUMBS, [])
                //    this.$store.commit(types.ADD_BREADCRUMB, parent)
                //}

                //this.$store.dispatch('getCategoriesByParent', this.selectedCategory)
                //this.$store.dispatch('getProductsByCategory', this.selectedCategory).then(() => {
                //    if (this.products && this.loggedInCustomer.id) {
                //        this.$store.dispatch('getDiscounts').then(() => {
                //            this.$store.commit(types.ADD_DISCOUNTS_TO_PRODUCTS, this.discounts)
                //            this.$store.dispatch('getPricesForCustomerOnAuth').then(() => {
                //                this.$store.commit(types.ADD_CUSTOMER_SPECIFIC_PRICES_TO_PRODUCTS, this.customerSpecificPrices)
                //            })
                //        })
                //    }
                //})
                //alert(category.id);
                //this.$router.push('categorie/' + category.id).catch(e => { alert(e) })
                //this.$router.push({ 'path': 'categorie', 'query': { 'id': category.id } }).catch(e => { alert(e) })
                this.$router.push({ name: 'categorie', params: { id: category.id } })
            },
            listCategory(id) {
                this.selectedCategory = id
                this.shouldShowAllProducts = false
                this.$store.commit(types.SET_SEARCHED_CATEGORIES, [])
                this.$store.dispatch('getCategoriesByParent', this.selectedCategory)
                this.$store.dispatch('getProductsByCategory', this.selectedCategory).then(() => {
                    if (this.products && this.loggedInCustomer.id) {
                        this.$store.dispatch('getDiscounts').then(() => {
                            this.$store.commit(types.ADD_DISCOUNTS_TO_PRODUCTS, this.discounts)
                            this.$store.dispatch('getPricesForCustomerOnAuth').then(() => {
                                this.$store.commit(types.ADD_CUSTOMER_SPECIFIC_PRICES_TO_PRODUCTS, this.customerSpecificPrices)
                            })
                        })
                    }
                })
            },
            toggleProductActivation(productId, isActive) {
                this.$store.commit(types.SET_PRODUCT_TO_UPDATE, { productId: productId, active: !isActive })
                this.$store.dispatch('toggleProductActivation')
            },
            toggleProductStar(productId, star) {
                this.$store.commit(types.SET_PRODUCT_TO_UPDATE, { productId: productId, star: !star })
                this.$store.dispatch('toggleProductStar')
            },
            toggleProductOffer(productId, offer) {
                this.$store.commit(types.SET_PRODUCT_TO_UPDATE, { productId: productId, offer: !offer })
                this.$store.dispatch('toggleProductOffer')
            },
            paginate: function (page) {
                console.log(`Page ${page} was selected. Do something about it ${this.access}`);
            }
        },
        computed: {
            ...mapGetters({
                topCategories: 'topCategories',
                categoriesByParent: 'categoriesByParent',
                products: 'products',
                breadcrumbs: 'breadcrumbs',
                searchedCategories: 'searchedCategories',
                discounts: 'discounts',
                customerSpecificPrices: 'customerSpecificPrices',
                loggedInCustomer: 'loggedInCustomer'
            }),
            totalProducts() {
                return this.products.filter(product => {
                    return (product.active || this.access == 'btonly') &&
                        (product.dutchTitle.toLowerCase().indexOf(this.searchInput.toLowerCase()) > -1 ||
                            product.articleNumber.toLowerCase().indexOf(this.searchInput.toLowerCase()) > -1 ||
                            product.frenchTitle.toLowerCase().indexOf(this.searchInput.toLowerCase()) > -1)
                }).sort((a, b) => a.articleNumber.localeCompare(b.articleNumber))
            },
            filteredProducts() {
                let start = (this.currentPage - 1) * this.perPage
                let end = start + this.perPage
                return this.totalProducts.slice(start, end)
            },
            filteredTopCategories() {
                return this.topCategories.sort((a, b) => a.dutchTranslation.localeCompare(b.dutchTranslation))
            },
            filteredCategoriesByParent() {
                return this.categoriesByParent.sort((a, b) => a.dutchTranslation.localeCompare(b.dutchTranslation))
            },
            filteredBreadcrumbs() {
                return this.breadcrumbs.reverse()
            },
            records() {
                return this.totalProducts.length
            }
        }
    }
</script>

<style scoped>

    .category .glyphicon {
        display: none;
    }

    .category:hover .glyphicon {
        display: inline-block;
    }

    .category-btn {
        margin-bottom: 2px;
        width: 85%;
        text-align: left;
        white-space: normal;
    }

        .category-btn:hover {
            width: 85%;
        }

    .add-category-btn {
        width: 90%;
        text-align: center;
    }

    @media screen and (max-width: 768px) {
        .category-btn {
            margin-bottom: 2px;
            width: 90vw;
            text-align: left;
            white-space: normal;
        }

            .category-btn:hover {
                width: 90vw;
            }

        .add-category-btn {
            width: 90vw;
            text-align: center;
        }
    }

    .card .glyphicon {
        display: none;
    }

    .card {
        padding: 0;
        margin-right: 40px;
        margin-bottom: 10px;
        cursor: pointer;
        height: 150px;
        width: 150px;
        background-color: white;
    }

        .card:hover .glyphicon {
            display: block;
        }

        .card p {
            text-align: center;
            font-weight: 600;
            margin-bottom: 30px;
        }

        .card img {
            width: auto;
            max-width: 175px;
            max-height: 150px;
            margin-bottom: 5px !important;
        }



    @media screen and (max-width: 768px) {
        .card img {
            width: 100px;
            margin-bottom: 5px !important;
        }
    }

    div .card {
        margin-bottom: 100px;
    }

    .breadcrumb {
        background: none;
    }

    a {
        cursor: pointer;
    }

    ol li.breadcrumb-link:last-child a {
        cursor: default;
        color: #2c3e50;
        text-decoration: none;
    }

    .mb-10 {
        margin-bottom: 10px;
    }

    .no-padding {
        padding: 0;
    }

    .glyphicon {
        top: 0;
        cursor: pointer;
    }

    .btn-success {
        margin-left: 10px;
    }
</style>
